import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const STransferDetailsPageContent = styled.div`
  ${setFlexDFFDC};
`;
